import React, { useContext, useRef } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import ContentToggleTickerSettings from "../content_toggles/ContentToggleTickerSettings";

const ElementSettingsTicker = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  const element = builder.selected().object;
  const variant = contextData.objects.variant;
  const website = contextData.objects.website;

  const builderRef = useRef(builder);
  builderRef.current = builder;
  const elementRef = useRef(element);
  elementRef.current = element;
  const variantRef = useRef(variant);
  variantRef.current = variant;

  const images = Object.values(variant.content_toggle_items || {})
    .filter(
      (item) => item.element_id == element.id && item.toBeDeleted !== true
    )
    .sort((a, b) => (a.position || 0) - (b.position || 0));

  const nextPosition = () => {
    const items = Object.values(
      variantRef.current.content_toggle_items || {}
    ).filter(
      (item) =>
        item.element_id == elementRef.current.id && item.toBeDeleted !== true
    );
    if (items.length === 0) return 1;
    return Math.max(...items.map((i) => i.position || 0)) + 1;
  };

  const handleUpload = () => {
    uploads.select("callback", {
      environment: window.environment,
      path: "/websites/" + website.id + "/",
      website_id: website.id,
      library: true,
      maxFiles: 50,
      callback: function (file_url) {
        builderRef.current.create(
          "content_toggle_items",
          {
            element_id: elementRef.current.id,
            position: nextPosition(),
            content: file_url,
            options: { alt: "", link: "" },
            create_initial_section: false,
          },
          { skip_select: true }
        );
      },
    });
  };

  return (
    <React.Fragment>
      <div className="col-xs-12 mt-3 mb-3">
        <button
          className="w-full text-center gap-2 border-solid border-[1px] py-3 px-5 rounded-lg text-xl ml-1 mr-1 cursor-pointer text-black hover:text-blue-600 dark:text-gray-400 dark:hover:text-white bg-white hover:bg-blue-100 dark:bg-slate-950 dark:hover:bg-slate-800 border-slate-200 hover:border-blue-100 dark:border-slate-800"
          onClick={handleUpload}
        >
          <i className="fa-solid fa-arrow-up-from-bracket mr-2"></i>
          Upload Images
        </button>
      </div>

      {images.length > 0 && (
        <React.Fragment>
          <div className="col-xs-12 mb-2">
            <span className="text-xl text-black dark:text-white">Images:</span>
          </div>

          <div
            className="sortable-container col-xs-12"
            data-sortable-name="content-toggle-list-items"
            data-object_type="content_toggle_items"
          >
            {images.map((img) => (
              <ContentToggleTickerSettings
                key={"content_toggle_item-" + img.id}
                toggle_item={img}
              />
            ))}
          </div>
        </React.Fragment>
      )}

      <VariantBuilderSetting
        object={element}
        label="Scroll Speed (px/s)"
        setting_name="[options][ticker-speed]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        value={element.options["ticker-speed"] || ""}
        placeholder={
          variant.options["ticker-speed"]
            ? variant.options["ticker-speed"]
            : element.options["ticker-speed"]
            ? element.options["ticker-speed"]
            : 50
        }
        min={1}
        max={500}
        range_step={"1"}
        allow_empty={true}
        show_reset={true}
      />

      <VariantBuilderSetting
        object={element}
        label="Gap Between Images"
        setting_name="[options][ticker-image-gap]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        value={element.options["ticker-image-gap"] || undefined}
        placeholder={variant.options["ticker-image-gap"] || "20"}
        min={0}
        max={200}
        range_step={"1"}
        allow_empty={true}
        show_reset={true}
        device="desktop"
      />

      <VariantBuilderSetting
        object={element}
        label="Gap Between Images"
        setting_name="[options][ticker-image-gap-mobile]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        value={element.options["ticker-image-gap-mobile"] || undefined}
        placeholder={
          element.options["ticker-image-gap"] ||
          variant.options["ticker-image-gap"] ||
          "20"
        }
        min={0}
        max={200}
        range_step={"1"}
        allow_empty={true}
        show_reset={true}
        device="mobile"
      />

      <VariantBuilderSetting
        object={element}
        label="Max Image Height"
        setting_name="[options][ticker-max-image-height]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        value={element.options["ticker-max-image-height"] || undefined}
        placeholder={variant.options["ticker-max-image-height"] || "120"}
        min={0}
        max={1000}
        range_step={"1"}
        allow_empty={true}
        show_reset={true}
        device="desktop"
      />

      <VariantBuilderSetting
        object={element}
        label="Max Image Height"
        setting_name="[options][ticker-max-image-height-mobile]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        value={element.options["ticker-max-image-height-mobile"] || undefined}
        placeholder={
          element.options["ticker-max-image-height"] ||
          variant.options["ticker-max-image-height"] ||
          "120"
        }
        min={0}
        max={1000}
        range_step={"1"}
        allow_empty={true}
        show_reset={true}
        device="mobile"
      />

      <VariantBuilderSetting
        object={element}
        label="Max Image Width"
        setting_name="[options][ticker-max-image-width]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        value={element.options["ticker-max-image-width"] || undefined}
        placeholder={variant.options["ticker-max-image-width"] || "300"}
        min={0}
        max={1000}
        range_step={"1"}
        allow_empty={true}
        show_reset={true}
        device="desktop"
      />

      <VariantBuilderSetting
        object={element}
        label="Max Image Width"
        setting_name="[options][ticker-max-image-width-mobile]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        value={element.options["ticker-max-image-width-mobile"] || undefined}
        placeholder={
          element.options["ticker-max-image-width"] ||
          variant.options["ticker-max-image-width"] ||
          "300"
        }
        min={0}
        max={1000}
        range_step={"1"}
        allow_empty={true}
        show_reset={true}
        device="mobile"
      />

      <VariantBuilderSetting
        object={element}
        label="Fade Edges"
        setting_name="[options][ticker-fade-edges]"
        setting_type="checkbox"
        object_type="elements"
        object_id={element.id}
        value={element.options["ticker-fade-edges"]}
        show_reset={true}
      />
    </React.Fragment>
  );
};

export default ElementSettingsTicker;
